import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import CreatePlan from './CreatePlanV2';
import AllPlansImage from './AllPlansImage';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const WorkPlans = () => {
  const { i18n } = useTranslation();
  const { token, isAdmin } = useAuth();
  const isRTL = i18n.language === 'ar';
  const [plans, setPlans] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  const fetchPlans = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/work-plans`, { headers });
      setPlans(res.data.plans || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [token]);

  useEffect(() => { fetchPlans(); }, [fetchPlans]);
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await axios.get(`${API}/employees`, { headers });
        setEmployees((res.data || []).map(e => ({ id: e.id, name: e.name, company_id: e.company_id, establishment_id: e.establishment_id, company_name: e.company_name || '' })));
      } catch (e) { console.error(e); }
    };
    fetchEmployees();
  }, [token]);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin w-8 h-8 border-4 border-slate-300 border-t-[#D4AF37] rounded-full" /></div>;

  if (showCreate) return <CreatePlan isRTL={isRTL} employees={employees} headers={headers} onClose={() => { setShowCreate(false); fetchPlans(); }} onCreated={() => { setShowCreate(false); fetchPlans(); }} />;

  return (
    <AllPlansImage
      isRTL={isRTL}
      plans={plans}
      headers={headers}
      isAdmin={isAdmin}
      onCreatePlan={() => setShowCreate(true)}
      onRefresh={fetchPlans}
    />
  );
};

export default WorkPlans;
